import { Button } from '@/components/ui/button.tsx'
import { cn } from '@/lib/utils.ts'
import type * as React from 'react'

type Props = {
  storyId: string | number
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void
  className?: string
}

export const BlockerStoryIdMarker = ({ storyId, onClick, className }: Props) => {
  return (
    <Button
      type="button"
      variant="ghost"
      className={cn(
        'p-1 bg-surface-backgroundElevated rounded-xs font-EN-KR-caption-regular h-[22px] hover:bg-surface-background after:hidden',
        className,
      )}
      onClick={onClick}
    >
      {`#${storyId}`}
    </Button>
  )
}
